import * as React from "react";
import { Component } from "react";
import styles from "../../styles/wizards/superadmin/AddDisciplineWizard.scss";
import autobind from "autobind-decorator";
import AddDisciplineIcon from "../../assets/images/add-discipline-64x64.svg";
import { mapStateToProps, setTableParams, validateForm } from "../../core/utils";
import { withRouter } from "react-router";
import { setNotification } from "../../redux/actions/general/notification";
import { createDiscipline, listDisciplines } from "../../redux/actions/table/superadmin/disciplines";
import AddDisciplineForm from "../../forms/superadmin/add_disciplines_wizard/AddDisciplineForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["superadmin_disciplines"],
}))
class AddDisciplineWizard extends Component {
	@autobind
	_handleSubmit(formData) {
		const { edit } = formData;

		return validateForm(
			createDiscipline(formData).then(({ response }) => {
				listDisciplines().then(() => {
					if (edit) {
						setTableParams('superadmin_disciplines', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('superadmin_disciplines', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification("You have successfully added a new discipline.");
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>Add discipline</span>
						<span>Add discipline to system disciplines</span>
					</div>
					<div className={styles.right}>
						<AddDisciplineIcon />
					</div>
				</div>
				<div className={styles.body}>
					<AddDisciplineForm onSubmit={this._handleSubmit} initialValues={{
						code: {},
						name: {},
						profession: {},
					}} />
				</div>
			</>
		);
	}
}

export default AddDisciplineWizard;